/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { GRID_COL_INDEX_ATTRIBUTE as r } from "../../constants/index.mjs";
import { uGrid as s, classNames as i } from "@progress/kendo-react-common";
const n = (e) => {
  let d = null;
  const l = e.unstyled, a = l && l.uGrid ? l.uGrid : s, t = i(
    a.td({ selected: e.isSelected, sorted: e.isSorted, alt: e.isAlt }),
    e.className,
    ["k-drag-cell", `${e.rowReorderable ? "" : "k-disabled"}`]
  );
  return d = {
    colSpan: e.colSpan,
    style: e.style,
    className: t,
    role: "gridcell",
    "aria-colindex": e.ariaColumnIndex,
    "aria-selected": e.isSelected,
    "aria-disabled": !e.rowReorderable,
    [r]: e.columnIndex
  }, { tdProps: d };
};
export {
  n as getRowReorderCellTdProps
};
